import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { signinApi } from '../../apis';
import { handleApiError } from '../../helpers';
import history from '../../helpers/history';
import { AuthenthicatedUserInfo, SigninDto, User } from '../../interfaces';
import { signin } from '../../states/action_creators';
import useResetError from '../useResetError';

const useSignin = () => {
  const [submiting, setSubmitting] = useState<boolean>(false);
  const { error, setError } = useResetError();
  const dispatch = useDispatch();

  const onSubmitHandler = async (payload: SigninDto) => {
    setSubmitting(true);
    setError(null);

    try {
      const response = await signinApi(payload);

      setSubmitting(false);

      const responseData: any = response.data;

      const user: AuthenthicatedUserInfo = {
        token: responseData.tokenData.token,
        user: responseData.user as User,
        profileCompleted: responseData.profileCompleted,
      };

      await dispatch(signin(user));

      if (user.profileCompleted) {
        history.replace('/dashboard');
      } else {
        history.replace('/complete-profile');
      }
    } catch (error) {
      setSubmitting(false);
      setError(handleApiError(error));
    }
  };
  return { onSubmitHandler, submiting, error };
};

export default useSignin;
